import React, { useEffect } from "react"
import * as XLSX from "xlsx";
import { FxButton } from "../button/FxButton";

export const ImportFile = (props: any) => {
    const { id, noFileErrorMsg, chooseFileLbl = "Choose File", invalidFileMsg = "Invalid file type" } = props;
    const [error, setError] = React.useState(false);
    let arrayBuffer: any;
    const defaultInvalidFile: any = false;
    const [invalidFile, setInvalidFile] = React.useState(defaultInvalidFile);
    const defaultInputFile: any = {};
    const [inputFile, setInputFile] = React.useState(defaultInputFile);

    const onFileChange = (event: any) => {
        let myfile: any = document.getElementById("myfile");
        let filePath = myfile.value;

        // Allowing file type
        let allowedExtensions = /(\.xlsx)$/i;

        if (!allowedExtensions.exec(filePath)) {
            setInputFile({});
            setInvalidFile(true);
            myfile.value = '';
            return false;
        }
        else {
            if (myfile.files && myfile.files[0]) {
                setInvalidFile(false);
                setInputFile(myfile.files[0]);
            }
        }
    };

    const onFileUpload = () => {
        if (!props.onImport) {
            alert(props.onImportRequiredAlertMsg);
            return;
        }
        let fileReader = new FileReader();
        fileReader.onload = (e) => {
            arrayBuffer = fileReader.result;
            let data = new Uint8Array(arrayBuffer);
            let arr = new Array();
            for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            let bstr = arr.join("");
            let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true, dateNF: 'yyyy/mm/dd;@' });
            let first_sheet_name = workbook.SheetNames[0];
            let worksheet = workbook.Sheets[first_sheet_name];
            props.onImport(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
            props.cancel();
        }
        if (inputFile) {
            let inptFile: any = inputFile;
            fileReader.readAsArrayBuffer(inptFile);
            setError(false);
            let fileVal: any = document.getElementById("myfile");
            fileVal.value = null;
            setInputFile({});
        } else {
            setError(true);
        }
    }

    return (
        <div id={id} className="import-file-root d-flex align-items-center justify-content-between">
            <div>
                <label htmlFor="myfile" id={`${id}-file`} className="custom-file-input">{chooseFileLbl}</label>
                {inputFile && inputFile.name ? inputFile.name : ''}
                <input type="file" id="myfile" name="myfile" onChange={onFileChange} style={{ display: "none" }} />
                <br />
                <span className="file-supported">{props.fileSupportedMsg}</span>
                {error &&
                    <div className="no-file-error">{noFileErrorMsg}</div>
                }
                {invalidFile &&
                    <div className="no-file-error">{invalidFileMsg}</div>
                }
            </div>
            <div>
                <FxButton label={props.fileUploadAction ? props.fileUploadAction : 'Upload!'} variant="contained" onClick={()=>onFileUpload()} />
            </div>
        </div>
    )
};